import { FileCogOutlineIcon } from './FileCogOutlineIcon';

/**
 * author: Simran
 * id 6ABE5D01-4204-46C0-B0D8-B3904C2E64C2
 * name file-cog-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-cog-outline.svg
 * tags
 * - Settings 
 * - Files / Folders 
 */
export const FileSettingsCogOutlineIcon = FileCogOutlineIcon;
export default FileSettingsCogOutlineIcon